import { Container } from "./container.js";
class ServiceRegistry {
    static{
        this.services = new Map();
    }
    static register(name, token, description, tags) {
        this.services.set(name, {
            token,
            description,
            tags
        });
    }
    static getByName(name) {
        return this.services.get(name)?.token;
    }
    static getByTag(tag) {
        const result = [];
        this.services.forEach((service, name)=>{
            if (service.tags?.includes(tag)) result.push({
                name,
                token: service.token,
                description: service.description
            });
        });
        return result;
    }
    static getAllServices() {
        const result = [];
        this.services.forEach((service, name)=>{
            result.push({
                name,
                token: service.token,
                description: service.description,
                tags: service.tags
            });
        });
        return result;
    }
    static clear() {
        this.services.clear();
    }
}
class ServiceBuilder {
    constructor(container, token){
        this.container = container;
        this.token = token;
    }
    asSingleton(implementation) {
        this.container.registerSingleton(this.token, implementation);
        return this;
    }
    asTransient(implementation) {
        this.container.registerTransient(this.token, implementation);
        return this;
    }
    asValue(value) {
        this.container.registerValue(this.token, value);
        return this;
    }
    asFactory(factory, deps = [], singleton = false) {
        this.container.registerFactory(this.token, factory, deps, singleton);
        return this;
    }
    withName(name, description, tags) {
        ServiceRegistry.register(name, this.token, description, tags);
        return this;
    }
}
class FluentContainer extends Container {
    bind(token) {
        return new ServiceBuilder(this, token);
    }
    singleton(token, implementation) {
        this.registerSingleton(token, implementation);
        return this;
    }
    transient(token, implementation) {
        this.registerTransient(token, implementation);
        return this;
    }
    value(token, value) {
        this.registerValue(token, value);
        return this;
    }
    factory(token, factory, deps = [], singleton = false) {
        this.registerFactory(token, factory, deps, singleton);
        return this;
    }
    module(configure) {
        configure(this);
        return this;
    }
}
function createFluentContainer() {
    return new FluentContainer();
}
const DIHelpers = {
    factory: (constructor, ...args)=>()=>new constructor(...args),
    singleton: (constructor, ...args)=>{
        let instance;
        return ()=>instance || (instance = new constructor(...args));
    },
    lazy: (factory)=>{
        let value;
        let initialized = false;
        return ()=>{
            if (!initialized) {
                value = factory();
                initialized = true;
            }
            return value;
        };
    }
};
export { DIHelpers, FluentContainer, ServiceBuilder, ServiceRegistry, createFluentContainer };
